import { render, staticRenderFns } from "./AdminDeleteFormCard.vue?vue&type=template&id=20bd137c&scoped=true&"
import script from "./AdminDeleteFormCard.vue?vue&type=script&lang=js&"
export * from "./AdminDeleteFormCard.vue?vue&type=script&lang=js&"
import style0 from "./AdminDeleteFormCard.vue?vue&type=style&index=0&id=20bd137c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bd137c",
  null
  
)

export default component.exports